<template>
  <div class="personal-page">
    <pc-page @logout="quit"></pc-page>
  </div>
</template>
<script>
import { isLogin } from '@/utils'
import compareVipRight from '@components/common/compareVipRight.js'
import PcPage from '../components/personalPage/PcPage'

export default {
  name: 'PersonalPage',
  mixins: [compareVipRight],
  data() {
    return {
      userInfo: {
        userName: '1111'
      },
      baseUrl: window.PROJECT_CONFIG.BASE_URL
    }
  },
  components: { PcPage },
  methods: {
    quit() {
      localStorage.setItem('userId', '')
      localStorage.setItem('token', '')
      window.location.href = this.baseUrl + '/fxsso/login'
      localStorage.setItem('username', '')
      localStorage.setItem('isChild', '')
      this.$store.commit('manage/UPDATE_BOOKS_CURRENT_ACCOUNT', '')
    }
  },
  mounted() {
    isLogin()
    this.getVipInfo()
  }
}
</script>
